import {
	Component,
	OnInit,
	ViewChild,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	HostListener,
	ViewChildren,
	ViewRef
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatMenuTrigger } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { tap } from 'rxjs/operators';
import { merge, BehaviorSubject } from 'rxjs';
//Datasource
import { NhapKhoVer2DataSource } from '../phieu-nhap-kho-ver2-datasource/phieu-nhap-kho-ver2.datasource';
//Service
import { DungChungService } from './../../../dung-chung/__services/dung-chung.service';
import { NhapKhoVer2Service } from '../phieu-nhap-kho-ver2-service/phieu-nhap-kho-ver2.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, QueryParamsModel, MessageType } from '../../../../../../core/_base/crud';
//Model
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { PhieuNhapKho } from '../phieu-nhap-kho-ver2-model/phieu-nhap-kho-ver2.model';
//Component
import { PhieuNhapKhoAddEditVer2Component } from '../phieu-nhap-kho-ver2-add-edit/phieu-nhap-kho-ver2-add-edit.component';
import { PhieuNhapKhoDetailVer2Component } from '../phieu-nhap-kho-ver2-detail/phieu-nhap-kho-ver2-detail.component';
import { XacNhanNhapKhoComponent } from '../xac-nhan-nhap-kho/xac-nhan-nhap-kho.component';
import { TokenStorage } from '../../../../../../core/auth/_services';

@Component({
	selector: 'm-phieu-nhap-kho-ver2-list',
	templateUrl: './phieu-nhap-kho-ver2-list.component.html',
	styleUrls: ['../phieu-nhap-kho-ver2.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})
export class NhapKhoVer2ListComponent implements OnInit {

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild('trigger', { static: true }) _trigger: MatMenuTrigger;
	@ViewChild('sort1', { static: true }) sort: MatSort;
	@ViewChildren('searchFullText') searchFullText ;


	/*----------------------------Config Form ---------------------------*/
	CONFIG: CommonConFig;
	/* ------------------------------------------------------------------*/


	/*--------------------Comment columns mat-table----------------------*/
	dataSource: NhapKhoVer2DataSource;
	displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'Sophieu',
			displayName: 'Số phiếu',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'LoaiPhieu',
			displayName: 'Loại phiếu',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'Ngaynhapkho',
			displayName: 'Ngày nhập kho',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'TenNguoitao',
			displayName: 'Người lập phiếu',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'Ngaytao',
			displayName: 'Ngày lập phiếu',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'DSNguoiThucHien',
			displayName: 'Danh sách người thực hiện',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 8,
			name: 'DienGiai',
			displayName: 'Diễn giải',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 9,
			name: 'TenTinhTrang',
			displayName: 'Trạng thái',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 99,
			name: 'actions',
			displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
		}
	];
	/* ------------------------------------------------------------------*/


	/* ------------------------------Selection ---------------------------*/
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<PhieuNhapKho>(true, []);
	/* ------------------------------------------------------------------*/


	/* --------------------------- Loading.... ---------------------------*/
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------*/


	/* ----------------------------- Filter ------------------------------*/
	haveFilter: boolean = false;
	filterGroupDataChecked: any = {};
	filterGroupDataCheckedFake: any = {};
	filterGroupData: any = {};
	filterGroupArray: any = {};
	filterText: any = {};
	tmpfilterText: any = {};
	disableButtonFilter: any = {};
	/* ------------------------------------------------------------------*/


	/*---------------------- Thông tin thao tác cho phiếu --------------- */
	phieuNhapKhoResult: PhieuNhapKho[] = [];
	tmpphieuNhapKhoResult: PhieuNhapKho[] = [];
	/* ------------------------------------------------------------------*/

	
	/* ------------------------------ ROLE ------------------------------*/
	TAO = '155';
	HUY = '0606';
	NHAP_KHO_CHI_TIET = '151';
	LIST_ROLES_USER: [] = [];
	SHOW_BUTTON_CREATE = new BehaviorSubject<boolean>(false);
	SHOW_BUTTON_REMOVE = new BehaviorSubject<boolean>(false);
	/* ------------------------------------------------------------------*/

	/*------------------------- Extend field: ----------------------------*/
	saveNew: number[] = []
	flagHighlight: boolean = false;
	previousIndex: number;
	fixedPoint = 2;
	isClearAll: boolean = false;
	openDialog: boolean = false;
	optionsTinhTrang = [];
	/* ------------------------------------------------------------------ */


	/* --------------------------- Qui trình -----------------------------*/
	CoQuyen: string = '0';
	/* ------------------------------------------------------------------ */

	constructor(
		private nhapKhoService: NhapKhoVer2Service,
		public dialog: MatDialog,
		private DungChungService: DungChungService,
		private router: Router,
		private tokenStorage: TokenStorage,
		private datePipe: DatePipe,
		private subheaderService: SubheaderService,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService) {
			let user = JSON.parse(localStorage.getItem("UserInfo"));
			this.LIST_ROLES_USER = user.roles;
		}

	/*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit() {
	
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.optionsTinhTrang = PhieuNhapKho.optionsTinhTrang;

		this.haveFilter = true;
		this.tmpfilterText = Object.assign({}, this.filterText);
		this.disableButtonFilter['SoPhieu'] = true;
		this.disableButtonFilter['TenNguoiTao'] = true;
		this.disableButtonFilter['Tinhtrang'] = true;
		this.disableButtonFilter['LoaiPhieu'] = true;
		this.disableButtonFilter['DSNguoiThucHien'] = true;

		this.filterGroupDataChecked['SoPhieu'] = '';
		this.filterGroupDataChecked['TenNguoiTao'] = '';

		let cocau = '';
		this.tokenStorage.getCoCauId().subscribe(r => cocau = r);
		this.DungChungService.listNVPB(+cocau).subscribe(res => {
			if(res && res.status == 1){
				var i = 0;
				this.filterGroupDataChecked['DSNguoiThucHien'] = res.data.map(x => {
					i = i + 1;
					return {
						id: i,
						name: x.TenNV,
						value: x.Id_NV,
						checked: false,
					}
				});
				this.filterGroupDataCheckedFake = Object.assign({}, this.filterGroupDataChecked);
			}

		});

		var i = 0;
		this.filterGroupDataChecked['LoaiPhieu'] = PhieuNhapKho.optionsLoaiPhieu.map(x => {
			i = i + 1;
			return {
				id: i,
				name: x.name,
				value: x.value,
				checked: false,
			}
		});
		this.filterGroupDataCheckedFake = Object.assign({}, this.filterGroupDataChecked);

		this.disableButtonFilter['Tinhtrang'] = true;
		this.filterGroupDataChecked['Tinhtrang'] = this.optionsTinhTrang.map(x => {
			return {
				id: x.id,
				name: x.name,
				value: x.value,
				checked: false
			}
		});

		this.filterGroupDataCheckedFake = Object.assign({}, this.filterGroupDataChecked);

		this.showColumnsInTable();
		this.applySelectedColumns();

		this.SHOW_BUTTON_CREATE.next(this.isTrueButton(this.TAO));
		this.SHOW_BUTTON_REMOVE.next(this.isTrueButton(this.HUY));
		
		this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
	
		merge(this.sort.sortChange, this.paginator.page)
			.pipe(
				tap(() => {
					this.loadListWithPageChange(false);
					this.forcusEvents();
				})
			)
			.subscribe();

		// // Set title to page breadCrumbs
		let breadcrumbs = [{ title: 'Kho' }, { title: 'Phiếu nhập kho', page: '/phieu-nhap-kho' }];
		this.subheaderService.setBreadcrumbs(breadcrumbs);

		// Init DataSource
		this.dataSource = new NhapKhoVer2DataSource(this.nhapKhoService);
		let queryParams = new QueryParamsModel({});

		this.dataSource.entitySubject.subscribe(res => {
			this.phieuNhapKhoResult = res
			this.tmpphieuNhapKhoResult = []
			if (this.phieuNhapKhoResult != null) {
				for (let i = 0; i < this.phieuNhapKhoResult.length; i++) {
					let tmpElement = new PhieuNhapKho();
					tmpElement.copy(this.phieuNhapKhoResult[i])
					this.tmpphieuNhapKhoResult.push(tmpElement);
				}
			}
		});
		this.loadList();
		this.layoutUtilsService.setUpPaginationLabels(this.paginator);
	}
	loadListWithPageChange(isDeleteAction: boolean) {
		this.selection.clear();
		let moveToPreviousPage = this.phieuNhapKhoResult.length == 1 && this.paginator.pageIndex > 0 ? true : false;
		if(moveToPreviousPage)
			this.paginator.pageIndex = this.paginator.pageIndex - 1
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize,
			this.filterGroupData
		);
		this.dataSource.loadList(queryParams);
	}
	loadList() {
		this.selection.clear();
		this.paginator.pageIndex = 0;
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize,
			this.filterGroupData
		);
		this.dataSource.loadList(queryParams);
	}
	filterConfiguration(): any {
		const filter: any = {};
		filter.CoQuyen = this.CoQuyen;
		filter.Search = this.searchFullText? this.searchFullText.first.nativeElement.value : "";
		return filter;
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------- CÁC THAO TÁC TRÊN FORM ----------------------*/
	add() {
		const newPhieuNhapKho = new PhieuNhapKho();
		newPhieuNhapKho.clear(); // Set all defaults fields
		newPhieuNhapKho.Tinhtrang = this.optionsTinhTrang[0].value;
		this.edit(newPhieuNhapKho);
	}
	edit(item: PhieuNhapKho) {
		if(this.checkDashboardRoute())	return null;
		if (item.IdNk > 0) {
			this.nhapKhoService.getChiTiet(item).subscribe(res => {
				if (res.status == 1) {
					item.listChiTietPhieuNhapKho = res.data.listChiTietPhieuNhapKho;
					const dialogRef = this.dialog.open(PhieuNhapKhoAddEditVer2Component, {
						data: { data: item },
						maxHeight: '90vh',
						width: '90vw'
					});

					dialogRef.afterClosed().subscribe(res => {
						this.forcusEvents();
						if (res == undefined || res == null) {
							return;
						}
						else {
							if (!res.isChange) {
								return;
							}
							if (res.dataAdd.length != 0) {
								this.saveNew = res.dataAdd;
							}
							this.loadListWithPageChange(false);
						}
					});
				}
				else {
					this.forcusEvents();
					this.layoutUtilsService.showErorr(res.error.message);
				}
			})
		}
		else {
			this.DungChungService.getBillNumber(PhieuNhapKho.category_path).subscribe(res => {
				if (res.status == 1) {
					item.Sophieu = res.data;
					const dialogRef = this.dialog.open(PhieuNhapKhoAddEditVer2Component, {
						data: {
							data: item,
							canEdit: this.isTrueButton(this.TAO)
						},
						maxHeight: '90vh',
						width: '90vw'
					});

					dialogRef.afterClosed().subscribe(res => {
						this.forcusEvents();
						if (res == undefined || res == null) {
							return;
						}
						else {
							if (!res.isChange) {
								return;
							}
							if (res.dataAdd.length != 0) {
								this.saveNew = res.dataAdd;
							}
							this.loadList();
						}
					});
				}
				else {
					const message = `Lỗi lấy số phiếu tiếp theo`;
					this.layoutUtilsService.showErorr(message);
				}
			});
		}
	}
	delete(_item: PhieuNhapKho) {
		if(this.checkDashboardRoute())	return null;
		const _deleteMessage = `Phiếu nhập kho đã được xóa`;
		const dialogRef = this.layoutUtilsService.POP01(_item.Sophieu);
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			}
			this.nhapKhoService.delete(_item.IdNk).subscribe(res => {
				if (res && res.status === 1) {
					this.layoutUtilsService.showInfo(_deleteMessage);
				}
				else {
					this.layoutUtilsService.showErorr(res.error.message);
				}
				this.loadListWithPageChange(true);
			});
		});
	}
	detail(item: PhieuNhapKho) {
		if(this.checkDashboardRoute())	return null;
		this.nhapKhoService.getChiTiet(item).subscribe(res => {
			if (res.status == 1) {
				item.listChiTietPhieuNhapKho = res.data.listChiTietPhieuNhapKho;
				item.Tinhtrang = res.data.Tinhtrang
				const dialogRef = this.dialog.open(PhieuNhapKhoDetailVer2Component, {
					data: {data: item},
					maxHeight: '90vh',
					width: '90vw'
				});

				dialogRef.afterClosed().subscribe(res => {
					this.forcusEvents();
					if (res == undefined || res == null) {
						this.loadListWithPageChange(false);
						return;
					}
					else {
						if (!res.isChange) {
							this.loadListWithPageChange(false);
							return;
						}
						if (res.dataAdd.length != 0) {
							this.saveNew = res.dataAdd;
						}
						this.loadListWithPageChange(false);
					}
				});
			}
			else {
				this.forcusEvents();
				this.layoutUtilsService.showErorr(res.error.message);
			}
		})
	}
	getNameNguoiThucHien(item: PhieuNhapKho) {
		let _index = this.phieuNhapKhoResult.findIndex(x => x.IdNk == item.IdNk);
		let listName = '';
		if (_index > -1) {
			this.phieuNhapKhoResult[_index].listNguoiThucHien.forEach(element => {
				listName += element.TenNguoiThucHien + ', ';
			})
			listName = listName.substring(0, listName.length - 2);
		}

		return listName;
	}
	xacNhan(item: PhieuNhapKho) {
		if(this.checkDashboardRoute())	return null;
		this.nhapKhoService.getChiTiet(item).subscribe(res => {
			if (res.status == 1) {
				if(res.data.Tinhtrang == this.optionsTinhTrang[1].value){
					item.listChiTietPhieuNhapKho = res.data.listChiTietPhieuNhapKho;
					const dialogRef = this.dialog.open(XacNhanNhapKhoComponent, {
						data: {data: item},
						maxHeight: '90vh',
						width: '90vw'
					});

					dialogRef.afterClosed().subscribe(res => {
						this.forcusEvents();
						if (res == undefined || res == null) {
							return;
						}
						else {
							if (!res.isChange) {
								return;
							}
							if (res.dataAdd.length != 0) {
								this.saveNew = res.dataAdd;
							}
							this.loadListWithPageChange(false);
						}
					});
				}
				else if(res.data.Tinhtrang == this.optionsTinhTrang[2].value){
					this.layoutUtilsService.showErorr('Phiếu đã bị hủy, vui lòng tải lại danh sách để kiểm tra');
				}
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		})
	}
	cancel(_item: PhieuNhapKho) {
		if(this.checkDashboardRoute())	return null;

		this.nhapKhoService.checkCancel(_item.IdNk).subscribe(res => {
			if (res && res.status === 1) {
				const _deleteMessage = `Phiếu nhập kho đã được hủy`;
				const dialogRef = this.layoutUtilsService.POP04(_item.Sophieu);

				dialogRef.afterClosed().subscribe(res => {
					if (!res) {
						return;
					}
					this.nhapKhoService.cancel(_item.IdNk).subscribe(res => {
						if (res && res.status === 1) {
							this.layoutUtilsService.showInfo(_deleteMessage);
							this.saveNew = [];
							this.saveNew.push(_item.IdNk);
						}
						else {
							this.layoutUtilsService.showErorr(res.error.message);
						}
						this.loadListWithPageChange(false);
					});
				});
			}
			else {
				this.layoutUtilsService.showErorr("Phiếu đang nhập kho. Bạn không được hủy phiếu");
			}
		});

		
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------ CÁC HÀM XÁC NHẬN CẤP QUYỀN ---------------------*/
	isTrueButton(ROLENUMBER: string) {
		if (this.LIST_ROLES_USER.findIndex(x => x == ROLENUMBER) > -1) {
			return true;
		}
		return false;
	}
	isCreate(item:any){
		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		let element = this.tmpphieuNhapKhoResult.find(x => x.IdNk == item.IdNk);
		if(element != null && (element.Nguoitao == +idUser)){
			return true;
		}
		return false;
	}
	/* -----------------------------------------------------------------------*/


	/*----------------------- CSS HIỂN THỊ CHO TRẠNG THAI --------------------*/
	getItemCssClassByStatus(status: any): string {
		switch (status) {
			case PhieuNhapKho.optionsTinhTrang[0].value:
				return this.CONFIG.COLOR_STATE._DangSoanThaoCase;;
			case PhieuNhapKho.optionsTinhTrang[1].value:
				return this.CONFIG.COLOR_STATE._ChoXacNhanXuLyCase;
			case PhieuNhapKho.optionsTinhTrang[2].value:
				return this.CONFIG.COLOR_STATE._HuyCase;
			case PhieuNhapKho.optionsTinhTrang[3].value:
				return this.CONFIG.COLOR_STATE._HoanTatCase;
		}
	}
	highlightNewestRecord(item: any) {
		var index = this.phieuNhapKhoResult.indexOf(item);
		let saveNew = this.saveNew.indexOf(this.phieuNhapKhoResult[index].IdNk)
		if (saveNew > -1) {
			this.saveNew.splice(saveNew, 1)
			return true;
		}
		return false;
	}
	/* -----------------------------------------------------------------------*/


	/*----------------------- CÁC HÀM SỰ KIỆN FOCUS --------------------------*/
	forcusEvents() {
		this.openDialog = false;
		this.changeDetectView();
	}
	disabledDialog(){
		this.openDialog = true;
		this.changeDetectView();
	}
	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (event.altKey && event.keyCode == 78 && !this.openDialog) {
			this.openDialog = true;
			this.add();
		}
	}
	checkDashboardRoute(){
		/* 
			Kiểm tra xem có phải đang ở dashboard không, nếu là trang dashboard thì không thực hiện
			các action trên component hiện tại.
		*/
		if(this.router.url === '/')
			return true;
		return false;
	}
	changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	/* -----------------------------------------------------------------------*/


	/*-------------------- HÀM HỖ TRỢ FORMAT DẠNG SỐ -----------------------*/
	ValidateChangeNumberEvent(columnName: string, item: any, event: any) {
		var count = 0;
		for (let i = 0; i < event.target.value.length; i++) {
			if (event.target.value[i] == '.') {
				count += 1;
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	/* -----------------------------------------------------------------------*/


	/*-------------------- HÀM HỖ TRỢ FORMAT DẠNG NGÀY -----------------------*/
	getFormatDate(v: string = '') {
		if (v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}
	f_convertDate(p_Val: any) {
		if (p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	/* -----------------------------------------------------------------------*/


	/* ---------- HÀM HỖ TRỢ HIỂN THỊ CỘT TRÊN MENU --------------------------*/
	IsAllColumnsChecked() {
		const numSelected = this.selectedColumns.selected.length;
		const numRows = this.availableColumns.length;
		return numSelected === numRows;
	}
	CheckAllColumns() {
		if (this.IsAllColumnsChecked()) {
			this.availableColumns.forEach(row => { if (!row.alwaysChecked) this.selectedColumns.deselect(row); });
		} else {
			this.availableColumns.forEach(row => this.selectedColumns.select(row));
		}
	}
	menuChange(e: any, type: 0 | 1 = 0) {
		this.layoutUtilsService.menuSelectColumns_On_Off();
	}
	/*----------------------------------------------------------------------- */


	/*-------- CÁC HÀM HỖ TRỢ CHUYỂN CỘT VÀ HIỂN THỊ CỘT TRONG BẢNG ----------*/
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	/*----------------------------------------------------------------------- */


	/*-----------------------------FILTER ON GRID ----------------------------*/
	removeText(col) {
		this.filterText[col] = "";
		this.loadList();
		this.forcusEvents();
	}
	SelectAll(event, col) {
		if (event.checked) {
			this.filterGroupDataCheckedFake[col].forEach(element => {
				element.checked = true;
			});
		}
		else {
			this.filterGroupDataCheckedFake[col].forEach(element => {
				element.checked = false;
			});
		}
	}
	isColumnSelectAll(col) {
		if (this.filterGroupDataCheckedFake[col]) {
			let lst_checked = this.filterGroupDataCheckedFake[col].filter(opt => opt.checked).map(opt => opt.value);
			if (lst_checked) {
				if (lst_checked.length != this.filterGroupDataCheckedFake[col].length) {
					return false;
				}
				else {
					return true;
				}
			}
			else {
				return false;
			}
		}
		return false;
	}
	LoadDataDropFilter(col) {
		this.tmpfilterText = Object.assign({}, this.filterText);
		if (this.filterGroupDataChecked && this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col] && this.filterGroupDataChecked[col]) {
			this.filterGroupDataCheckedFake[col] = this.filterGroupDataChecked[col].map(x => Object.assign({}, x));
		}
	}
	disableDoneButton(col , isSelect = true) {
		let countChecked = 0;
		
		if(isSelect){
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				for (var elementFake of this.filterGroupDataCheckedFake[col]) {
					if (elementFake.checked) {
						countChecked++;
					}
				}
			}
			if (countChecked > 0) {
				this.disableButtonFilter[col] = false;
			}
			else {
				this.disableButtonFilter[col] = true;
			}
		}else{
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				if (this.filterGroupDataCheckedFake[col].length > 0) {
					this.disableButtonFilter[col] = false;
				}
				else {
					this.disableButtonFilter[col] = true;
				}
			}
		}
	}
	showClearAllButton() {
		let _count = 0;
		for (var key in this.filterGroupArray) {
			if (this.filterGroupArray.hasOwnProperty(key)) {
				if (this.filterGroupArray[key]) {
					let _arrflt = this.filterGroupArray[key].filter(opt => opt.checked);
					if(_arrflt.length == 0 && this.filterGroupArray[key].length == 1){
						_arrflt = this.filterGroupArray[key].filter(opt => opt);
					}
					_count += _arrflt ? _arrflt.length : 0;
				}
			}
		}
		let _text = "";
		for (var key in this.filterText) {
			if (this.filterText.hasOwnProperty(key)) {
				_text += this.filterText[key];
			}
		}
		if (_count > 0 || _text) {
			this.isClearAll = true;
		}
		else {
			this.isClearAll = false;
		}
	}
	filterHead(col, isSelect = true) {
		if(isSelect){
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				for (var elementFake of this.filterGroupDataCheckedFake[col]) {
					let index = this.filterGroupDataChecked[col].findIndex(x => x.id == elementFake.id);
					if (index > -1)
						this.filterGroupDataChecked[col][index].checked = elementFake.checked;
				}
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = this.filterGroupDataCheckedFake[col]
					.filter(opt => opt.checked);
				this.filterGroupData[col] = this.filterGroupDataCheckedFake[col]
					.filter(opt => opt.checked).map(op => op.value);

				this.filterGroupDataCheckedFake[col] = this.filterGroupDataChecked[col].map(x => Object.assign({}, x));
				this.tmpfilterText[col] = '';
			}
			this.filterText = Object.assign({}, this.tmpfilterText);
			if (this.filterText) {
				this.filterConfiguration();
			}
			this.loadList();
			this.isClearAll = this.checkFilterHasValue(this.filterGroupDataChecked, 'ALL');
		}else{
			if (this.filterGroupDataCheckedFake ) {
				if(!this.filterGroupDataCheckedFake[col]){
					this.remove('', col, false);
				}else{
					this.filterGroupData[col] = [];
					this.filterGroupArray[col] = [this.filterGroupDataCheckedFake[col]];
					this.filterGroupData[col] = [this.filterGroupDataCheckedFake[col]];
					if(this.filterGroupData[col]) 
						this.tmpfilterText[col] = '';
				}
			}
			this.filterText = Object.assign({}, this.tmpfilterText);
			if (this.filterText) {
				this.filterConfiguration();
			}
			this.loadList();
			this.isClearAll = this.checkFilterHasValue(this.filterGroupDataCheckedFake, col, false);
			this.filterGroupDataCheckedFake[col] = '';
		}
	}
	remove(item, col, isSelect = true) {
		if(isSelect){
			let _index = this.filterGroupDataChecked[col].findIndex(x => x.value == item.value);
			if (_index > -1) {
				this.filterGroupDataChecked[col][_index].checked = false;
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = this.filterGroupDataChecked[col]
					.filter(opt => opt.checked);
				this.filterGroupData[col] = this.filterGroupDataChecked[col]
					.filter(opt => opt.checked).map(op => op.value);

				if (this.filterGroupData[col] != null && this.filterGroupData[col].length == 0) {
					this.filterGroupData[col] = null
					this.filterText[col] = '';
					this.disableButtonFilter[col] = true;
				}
				this.loadList();
			}
		}else{
			let _index = this.filterGroupDataCheckedFake[col].length;
			if (_index > -1) {
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupData[col] = [];

				if (this.filterGroupData[col] != null && this.filterGroupData[col].length == 0) {
					this.filterGroupData[col] = null
					this.filterText[col] = '';
					this.disableButtonFilter[col] = true;
				}
				this.filterGroupDataCheckedFake[col] = '';
				this.loadList();
			}
		}
		
	}
	Clear() {
		this.filterGroupData = [];
		this.filterGroupArray = [];
		for (var key in this.filterGroupDataChecked) {
			if (this.filterGroupDataChecked.hasOwnProperty(key)) {
				if (this.filterGroupDataChecked[key]) {
					this.filterGroupDataChecked[key].forEach(element => {
						element.checked = false;
					});
					this.disableButtonFilter[key] = true;
				}
			}
		}
		for (var key in this.filterText) {
			if (this.filterText.hasOwnProperty(key)) {
				this.filterText[key] = "";
			}
		}
		this.isClearAll = false;
		this.loadList();
		this.forcusEvents();
	}
	checkFilterHasValue(data, col, isSelect = true) {
		let _count = 0;
		if(isSelect){
			if (col == 'ALL' && data) {//check all column
				for (var key in data) {
					if (data.hasOwnProperty(key)) {
						if (data[key]) {
							let _arrflt = data[key].filter(opt => opt.checked);
							_count += _arrflt ? _arrflt.length : 0;
						}
					}
				}
				let _text = "";
				for (var key in this.filterText) {
					if (this.filterText.hasOwnProperty(key)) {
						_text += this.filterText[key];
					}
				}
				if (_count > 0 || _text) {
					return true;
				}
			}
			else {//check in 1 column
				if (data && data[col]) {
					let _arrflt = data[col].filter(opt => opt.checked);
					_count += _arrflt ? _arrflt.length : 0;
				}
				if (_count > 0) {
					return true;
				}
			}
		}else{
			if(data && data[col] && data[col].length > 0){
				if (data[col].length > 0) {
					return true;
				}
			}
		}
		return false;
	}
	filterGroupWithTextFilter(columnName: string) {
		let search = this.tmpfilterText[columnName]

		if (!search) {
			this.filterGroupDataCheckedFake[columnName] = this.filterGroupDataChecked[columnName].map(x => Object.assign({}, x));
			return;
		} else {
			search = search.toLowerCase();
		}

		this.filterGroupDataCheckedFake[columnName] = this.filterGroupDataChecked[columnName].filter(
			ts => ts.name.toLowerCase().indexOf(search) > -1)

		this.changeDetect.detectChanges();
	}
	/* ---------------------------------------------------------------------- */
}
